/**
 * Safe sessionStorage helpers for persisting filter state across navigation.
 */

export function getPersistedFilters<T>(key: string): T | null {
  try {
    const stored = sessionStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored) as T;
    }
  } catch {
    // Ignore parse errors or disabled sessionStorage
  }
  return null;
}

export function setPersistedFilters<T>(key: string, value: T): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Ignore quota or disabled sessionStorage errors
  }
}
